import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';
import type { SpreadLiveSnapshotDto } from '@/api/types/spreadMonitoring';

// Live Spread hub (/hubs/spread-monitoring). Subscribe() on connect, server pushes
// SpreadSnapshot(SpreadMonitoringLiveSnapshotDto). Mirrors LiveSpread/index.js.
export function useSpreadLive({
  enabled,
  onData,
  onError,
}: {
  enabled: boolean;
  onData: (data: SpreadLiveSnapshotDto) => void;
  onError?: (message: string) => void;
}): { status: ConnectionStatus } {
  const { status } = useSignalRHub({
    url: '/hubs/spread-monitoring',
    enabled,
    on: {
      SpreadSnapshot: (data) => onData(data as SpreadLiveSnapshotDto),
    },
    onConnected: (conn) => {
      // Subscribe to the stream, then force a fresh snapshot so the grid is current
      // on (re)entering the Live tab — mirrors LiveSpread/index.js RequestSnapshot.
      void conn
        .invoke('Subscribe')
        .then(() => conn.invoke('RequestSnapshot'))
        .catch(() => onError?.('Failed to connect to live spread updates.'));
    },
  });
  return { status };
}
